import { useTranslation } from 'react-i18next'
import { useFormatAmount } from 'core/hooks/useFormatAmount'

const isGood = (value: string) => {
  return value === 'GOOD'
}

const isBad = (value: string) => {
  return value === 'BAD'
}

interface YearlyGraphExplanationsProps {
  yearToDateEvaluation?: string
  yearEvaluation?: string
  forecastTrajectoryGap?: number
  currency?: string
}

const YearlyGraphExplanations = ({
  yearToDateEvaluation = null,
  yearEvaluation = null,
  forecastTrajectoryGap = null,
  currency = null
}: YearlyGraphExplanationsProps) => {
  const { t } = useTranslation()
  const formatAmount = useFormatAmount()

  const getTextWithGap = (translationKey: string, forecastTrajectoryGap: number) =>
    t(translationKey, {
      FORECAST_TRAJECTORY_GAP: formatAmount(forecastTrajectoryGap, currency ?? '')
    })

  return (
    <span data-testid="yearly-graph-explanations">
      {isGood(yearToDateEvaluation) &&
        isGood(yearEvaluation) &&
        getTextWithGap('general.cumulative_charts.message.behind_your_trajectory', forecastTrajectoryGap)}

      {isGood(yearToDateEvaluation) &&
        isBad(yearEvaluation) &&
        getTextWithGap('general.cumulative_charts.message.over_your_trajectory', forecastTrajectoryGap)}

      {isBad(yearToDateEvaluation) &&
        isGood(yearEvaluation) &&
        getTextWithGap('general.cumulative_charts.message.is_your_forecast_realistic', forecastTrajectoryGap)}

      {isBad(yearToDateEvaluation) &&
        isBad(yearEvaluation) &&
        getTextWithGap('general.cumulative_charts.message.below_your_trajectory', forecastTrajectoryGap)}
    </span>
  )
}

export default YearlyGraphExplanations
